import React from 'react';
import { SignUpLayoutContainerProps } from '../../../sign-up-layout-container';
import { SlackPromoConfluenceFirstImpressionsLayout } from './slack-promo-confluence-view-first-impressions-layout';
import { SlackPromoConfluenceStandaloneLayout } from './slack-promo-confluence-view-standalone-layout';

export function SlackPromoConfluenceView(props: SignUpLayoutContainerProps) {
  switch (props.layout) {
    case 'standalone':
      return <SlackPromoConfluenceStandaloneLayout />;
    default:
      return <SlackPromoConfluenceFirstImpressionsLayout />;
  }
}
